import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import CustomerModalSubtitle from "./CustomerModalSubtitle";
import CrmTaskFields from "./CrmTaskFields";

const CrmTaskModal = ({
  titleKey,
  open,
  onCancel,
  onOk,
  okTextKey = "save",
  cancelTextKey = "cancel",
  confirmLoading,
  footer,
  width,
  customerName,
  title,
  onTitleChange,
  dueAt,
  onDueAtChange,
  assigneeUid,
  onAssigneeUidChange,
  cmsUsers,
  defaultAssigneeUid,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t(titleKey)}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText={t(okTextKey)}
      cancelText={t(cancelTextKey)}
      confirmLoading={confirmLoading}
      footer={footer}
      width={width}
    >
      <CustomerModalSubtitle customerName={customerName} />
      <CrmTaskFields
        title={title}
        onTitleChange={onTitleChange}
        dueAt={dueAt}
        onDueAtChange={onDueAtChange}
        assigneeUid={assigneeUid}
        onAssigneeUidChange={onAssigneeUidChange}
        cmsUsers={cmsUsers}
        defaultAssigneeUid={defaultAssigneeUid}
      />
    </Modal>
  );
};

export default CrmTaskModal;
